import { render, staticRenderFns } from "./RegisterDeliveryModal.vue?vue&type=template&id=9a2546d8&scoped=true"
import script from "./RegisterDeliveryModal.vue?vue&type=script&lang=ts"
export * from "./RegisterDeliveryModal.vue?vue&type=script&lang=ts"
import style0 from "./RegisterDeliveryModal.vue?vue&type=style&index=0&id=9a2546d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2546d8",
  null
  
)

export default component.exports